/**
 * This is the main JavaScript entrypoint for the Maps detail page
 */

import Washi from 'washi';
import Map from '../../src/map/mixins/map';

Washi(Map, {
  el: '#map-outer',
  defaultMarker: window.mapMarker,
  disableEvents: true,
  lockBoundaries: false,
  mapHeight: window.mapHeight,
});
